import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

import {createElement, PropTypes} from 'rlink-react';
import LegacyScrollTransition from 'rlink-transitions/LegacyScrollTransition';

export default function EliteDescriptionPanelOrks ({css}) {
  return (
    <LegacyScrollTransition css={css}>
      <div className={css.column}>
        <h1>
          <FormattedHTMLMessage
            id="ui.branding.heading.DOW3_GORGUTZ_EADUNTER_DESCRIPTION_PANEL_ANIMATED_TAGLINE"
            defaultMessage={'<span class="{FIRST_CLASSNAME}">Gorgutz</span> <span class="{SECOND_CLASSNAME}">’Ead’unter</span>'}
            description="Animated tagline appearing on the Orks faction page. The two different <span>...</span> parts fade-in one after the other and should be of roughly equal size. {FIRST_CLASSNAME} and {SECOND_CLASSNAME} are used to give the different parts their animations and should remain in order."
            values={{
              FIRST_CLASSNAME: css.first,
              SECOND_CLASSNAME: css.second,
            }} />
        </h1>
        <hr style={{marginLeft: 0}} className={css.short} />
        <p>
          <FormattedMessage
            id="ui.branding.copy.GORGUTZ_EADUNTER_DESCRIPTION_PANEL_BODY"
            defaultMessage="Cunning, greedy, and brutal in equal measure, Gorgutz ‘Ead’unter has collected an array of skulls to adorn his armour. His huge form is covered in the marks of a thousand battles and he is always searching for the biggest and best weapons – such as the huge Power Klaw that has replaced his entire right arm."
            description="Paragraph description of the Orks hero. Gorgutz ‘Ead’unter is a character name." />
        </p>
      </div>
    </LegacyScrollTransition>
  );
}

EliteDescriptionPanelOrks.propTypes = {
  css: PropTypes.object,
};



// WEBPACK FOOTER //
// ./apps/www.dawnofwar.com/src/components/EliteDescriptionPanelOrks.jsx